import styled from "styled-components"

export const DeleteButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 2rem;
  border: 0.1rem solid ${(p) => p.theme.colors.errorBorder};
  color: ${(p) => p.theme.colors.errorText};
  background: ${(p) => p.theme.colors.white};
  font-size: 1.3rem;
  border-radius: 0.5rem;
  height: 4rem;
  cursor: pointer;
  transition: all 0.2s;
  letter-spacing: 0.05rem;

  &:hover {
    background: ${(p) => p.theme.colors.errorBackground};
  }
`
